module.exports = __webpack_public_path__ + "img/icon_clsc.87b4a9c4.png";